<template>
  <div class="media-files">
    <div class="media-files_headline">
      <div class="media-files_left">
        <div class="media-files_search">
          <label for="file">Поиск</label>
          <input
            id="file"
            v-model="search"
            class="media-files_search-input"
          />
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
          </svg>
        </div>
        <div class="media-files_select">
          <label for="type">Тип файла</label>
          <v-select
            id="type"
            :items="mediaType"
            v-model="filter.fileType"
            class="media-files_search-select"
            hide-details
            height="40"
            outlined
            @change="mediaFilter(filter)"
          ></v-select>
        </div>
      </div>
      <div class="media-files_right">
        <div class="media-files_switch">
          <label for="switch">Мои файлы</label>
          <v-switch
            v-model="filter.author"
            @change="mediaFilter(filter)"
            color="primary"
            id="switch"
            :value="userID"
            hide-details
          ></v-switch>
        </div>
        <div class="media-files_button">
          <button type="button" name="button" class="media-files_btn btn-add" @click="dialog = true">+ Добавить файл</button>
        </div>
      </div>
    </div>
    <v-data-table
      :key="tableKey"
      :headers="headers"
      :items="mediaData"
      :loading="loading"
      sort-by="created"
      :sort-desc="true"
      loading-text="Данные загружаются..."
      class="elevation-1"
      ref="table"
      @pagination="paginations($event)"
      :page="page"
      hide-default-footer
      :items-per-page="itemsPerPage"
      :search="search"
      >
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex" v-if="item.update">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                @click="saveEdit(item)"
                v-bind="attrs"
                v-on="on"
                class="mr-2"
              >
                mdi-content-save
              </v-icon>
            </template>
            <span>Сохранить</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                @click="removeEdit(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-close
              </v-icon>
            </template>
            <span>Отменить</span>
          </v-tooltip>
        </div>
        <div class="d-flex" v-else>
          <v-tooltip bottom v-if="item.canEdit">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="downloadFiles(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-download
              </v-icon>
            </template>
            <span>Скачать файл</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.canEdit">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                @click="view(item)"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Просмотр</span>
          </v-tooltip>

          <v-tooltip bottom v-if="item.canEdit">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                @click="deleteItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:[`item.fileTitle`]="{ item }">
        <v-text-field v-if="item.update" outlined hide-details v-model="editedItem.ftitle"></v-text-field>
        <span v-else>{{item.fileTitle}}</span>
      </template>
      <template v-slot:[`item.created`]="{ item }">
        {{ item.created | filterBirthday }}
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <v-text-field v-if="item.update" label="Описание" outlined hide-details v-model="editedItem.desc"></v-text-field>
        <span v-else>{{item.description}}</span>
      </template>
      <template v-slot:[`item.mediaFileTagsSearch`]="{ item }">
        <!-- <span v-if="!item.update && item.mediaFileTags">
            {{
                item.mediaFileTags.map(item => {
                    if (item.mediaFileTag) {
                        return item.mediaFileTag.tagName
                    }
                }).join(', ')
            }}
        </span> -->
        <v-chip
            v-show="!item.update && item.mediaFileTags.length > 0"
            v-for="(el, key) in item.mediaFileTagsList"
            :key="'m'+key"
            class="ma-1"
            small
        >
            {{ el }}
        </v-chip>

        <v-autocomplete
          ref="autocomplit"
          v-if="item.update"
          :items="mediaTags"
          v-model="editedItem.tags"
          auto-select-first
          dense
          chips
          label="Тeги"
          clearable
          hide-details
          outlined
          deletable-chips
          multiple
          small-chips
         >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                <v-btn color="blue" @click.stop.prevent="saveTags('autocomplit')">Добавить тэг</v-btn>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:footer="{ props }">
        <div class="data-footer">
          <div class="items-per-page">
            <span>Строк на странице:</span>
            <div class="items-per-page_item" :class="{active: itemsPerPage == 5}" @click.prevent="itemsPerPage = 5">
              5
            </div>
            <div class="items-per-page_item" :class="{active: itemsPerPage == 10}" @click.prevent="itemsPerPage = 10">
              10
            </div>
            <div class="items-per-page_item" :class="{active: itemsPerPage == 15}" @click.prevent="itemsPerPage = 15">
              15
            </div>
            <div class="items-per-page_item" :class="{active: itemsPerPage == -1}" @click.prevent="itemsPerPage = -1">
              все
            </div>
          </div>
          <div class="pagination" v-if="itemsPerPage != -1">
            <div class="pagination_prev" @click.prevent="page == 1 ? page : --page">
              <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
              </svg>
            </div>
            <div class="pagination_number">
              {{itemsPerPage * (page - 1) + 1}} - {{itemsPerPage * (page - 1) + itemsPerPage}} из {{props.pagination.itemsLength}}
            </div>
            <div class="pagination_next" v-if="itemsPerPage" @click.prevent="page == parseInt(props.pagination.itemsLength / itemsPerPage, 10) ? page : ++page">
              <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
              </svg>
            </div>
          </div>
        </div>
      </template>
    </v-data-table>

    <ViewDialog ref="viewDialog" />

    <v-dialog v-model="dialog" max-width="489px">
      <div class="add-files">
        <div class="add-files_header">
          <h2>Добавить медиафайл</h2>
          <button class="filter-btn" @click="close()">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
              <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <validation-observer
          ref="observer"
          v-slot="{ invalid }"
          >
          <form class="add-files_form form" @submit.prevent="save()">
            <validation-provider
              v-slot="{ errors }"
              name="Описание"
              rules="required"
            >
              <label class="add-files_form-label" for="desc">Описание</label>
              <v-text-field
              id="desc"
              v-model="newItem.desc"
              :error-messages="errors"
              hide-details
              outlined
              required>
              </v-text-field>
            </validation-provider>
            <label class="add-files_form-label" for="tegs">Теги</label>
            <v-autocomplete
              id="tegs"
              :items="mediaTags"
              v-model="newItem.tags"
              auto-select-first
              hide-details
              outlined
              ref="autocomplit1"
              chips
              clearable
              deletable-chips
              multiple
              small-chips
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn color="blue" @click.stop.prevent="saveTags('autocomplit1')">Добавить тэг</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>

            <validation-provider
              v-slot="{ errors }"
              name="Файл"
              rules="required"
            >
              <label class="add-files_form-label" for="file">Файл</label>
              <v-file-input
                v-model="newItem.file"
                hide-details
                id="file"
                outlined
                placeholder="Файл jpg, jpeg, png, mp4, mp3"
                :error-messages="errors"
                accept="image/png, image/jpeg, image/bmp, video/mp4, audio/mp3"
                required
              ></v-file-input>
            </validation-provider>
            <div class="form_item">
              <button :disabled="invalid" type="submit" class="form_item-submit">Сохранить</button>
            </div>
          </form>
        </validation-observer>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from "vuex";
  import "./MediaFiles.scss";
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import ViewDialog from './ViewDIalog.vue';
  setInteractionMode('eager')
  extend('required', {
    ...required,
    message: '{_field_} Заполните поле',
  })

  export default {
    name: 'MediaFiles',
    components: {
      ViewDialog,
      ValidationProvider,
      ValidationObserver,
    },
    data: () => ({
      pagination: {
        sortBy: 'name'
      },
      page: 1,
      itemsPerPage: 10,
      filter: {
        author: '',
        fileType: '',
      },
      loading: false,
      search: '',
      selected: [],
      dialog: false,
      tableKey: 0,
      valid: false,
      headers: [
        { text: 'Дата создания', value: 'created', width: 150 },
        { text: 'Описание', value: 'description', width: 400 },
        { text: 'Тeги', value: 'mediaFileTagsSearch', width: 300 },
        { text: 'Файл', value: 'fileName' },
        { text: 'Код для теста', value: 'id' },
        { text: '', value: 'actions', sortable: false, align: 'right', width: 130 }
      ],
      editedItem: {
        ftitle: '',
        desc: '',
        tags: '',
        file: [],
      },
      newItem: {
        ftitle: '',
        desc: '',
        tags: '',
        file: [],
      },
    }),

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.loading = true;

      this.getFiles().then(() => {
        this.loading = false;
      });

      this.getTags();
    },

    computed: {
      ...mapGetters({
        mediaType: "media/mediaType",
        mediaData: "media/mediaData",
        apiImg: "apiImg",
        userID: "login/userID",
        mediaTags: 'media/mediaTags'
      }),
    },
    methods: {
      ...mapActions({
        getFiles: "media/getFiles",
        create: 'media/create',
        download: 'media/download',
        delete: 'media/delete',
        updateFile: 'media/updateFile',
        getTags: 'media/getTags'
      }),
      ...mapMutations({
        mediaFilter: "media/mediaFilter",
        saveNewTags: "media/saveNewTags",
      }),
      paginations(event) {
        this.page = event.page
        this.itemsPerPage = event.itemsPerPage
      },
      view(item) {
        this.$refs.viewDialog.open(item);
      },
      downloadFiles(item) {
        this.loading = true
        this.download(item).then(() => this.loading = false)
      },

      saveTags(name) {
        this.saveNewTags(this.$refs[name].lazySearch )
        this.$refs[name].value
        ? this.$refs[name].value.push(this.$refs[name].lazySearch)
        : this.$refs[name].setValue([this.$refs[name].lazySearch])
        this.$refs[name].lazySearch = ''
      },

      save() {
        this.$refs.observer.validate()
        this.loading = true
        this.create(this.newItem).then(() => {
          this.getFiles().then(() => this.loading = false)
          this.tableKey = ++this.tableKey
        })
        this.close()
      },

      editItem (item) {
        const tag = []
        item.mediaFileTags.forEach(item => {
          tag.push(item.mediaFileTag.tagName)
        })
        this.mediaData.map(item => {
          item.update = false
        })
        item.update = true
        this.editedItem = {
          ftitle: item.fileTitle,
          desc: item.description,
          tags: tag,
          id: item.id
        }
        this.tableKey = ++this.tableKey
      },

      defaultItem() {
        this.editedItem = {
          ftitle: '',
          desc: '',
          tags: '',
          file: [],
        }
      },

      removeEdit(item) {
        item.update = false
        this.defaultItem()
        this.tableKey = this.tableKey++
      },

      saveEdit(item) {
        this.updateFile(this.editedItem).then(() => {
          item.update = false
          this.defaultItem()
          this.getFiles()
        })
        this.tableKey = this.tableKey++
      },

      deleteItem (item) {
        if (confirm("удалить файл?")) {
          this.delete(item)
        }
      },

      close () {
        this.dialog = false
        this.newItem = {
          ftitle: '',
          desc: '',
          tags: '',
          file: [],
        }
        setTimeout(() => {
          this.defaultItem()
        }, 300)
      },
    }
  }
</script>
